import React, { useEffect, useState } from "react";
import axios from "axios";
import DataUserLoyalty from "../store/DataUserLoyalty";
import { observer } from "mobx-react-lite";
import { useSearchParams } from "react-router-dom";

const TableMap = observer(() => {
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [maxX, setMaxX] = useState(1);
  const [maxY, setMaxY] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");

  useEffect(() => {
    setIsLoading(true); // Начинаем загрузку
    axios
      .post(
        "https://qh9pl2rhya.execute-api.eu-west-1.amazonaws.com/dev/iiko/get_tables_schema",
        {
          place_id: placeId,
          action: "get_tables_schema",
        }
      )
      .then((res) => {
        const zalTables =
          res.data.data[DataUserLoyalty.tableSide]?.tables || [];

        const filteredTables = zalTables.filter((t) => {
          const pos = t.position;
          return (
            pos && pos.width > 0 && pos.height > 0 && pos.x !== 0 && pos.y !== 0
          );
        });

        const calcMaxX = Math.max(
          ...filteredTables.map((t) => t.position.x + t.position.width),
          1
        );
        const calcMaxY = Math.max(
          ...filteredTables.map((t) => t.position.y + t.position.height),
          1
        );

        setMaxX(calcMaxX);
        setMaxY(calcMaxY);
        setTables(filteredTables);
        setIsLoading(false); // Завершили загрузку
      })
      .catch((err) => {
        console.error("Ошибка загрузки столов:", err);
        setIsLoading(false);
      });
  }, [DataUserLoyalty.tableSide]);

  const handleTableClick = (table) => {
    setSelectedTable(table);
    alert(`Вы выбрали ${table.name}`);
  };

  return (
    <div className='relative w-full max-w-full h-[45vh] bg-white overflow-hidden flex items-center justify-center'>
      {isLoading ? (
        <div className='flex items-center justify-center'>
          <div className='w-10 h-10 border-4 border-blue-400 border-t-transparent rounded-full animate-spin'></div>
        </div>
      ) : (
        tables.map((table) => {
          const { x, y, width, height } = table.position;

          const leftPercent = (x / maxX) * 100;
          const topPercent = (y / maxY) * 100;
          const widthPercent = (width / maxX) * 100;
          const heightPercent = (height / maxY) * 100;

          const isSelected = selectedTable?.table_id === table.table_id;

          return (
            <div
              key={table.table_id}
              onClick={() => handleTableClick(table)}
              className={`absolute flex items-center justify-center text-xs border border-[#69C0FF] rounded cursor-pointer ${
                isSelected ? "bg-green-500 text-white" : "bg-white"
              }`}
              style={{
                top: `${topPercent}%`,
                left: `${leftPercent}%`,
                width: `${widthPercent}%`,
                height: `${heightPercent}%`,
              }}
            >
              {table.number}
            </div>
          );
        })
      )}
    </div>
  );
});

export default TableMap;
